import { Icons } from '@Assets/SvgIcons';
import { Button, Dialog, InputBase, MenuItem, Select } from '@mui/material';
import { SelectedInvitetoDealItem } from 'pages/DealspaceDirectory/model';
import React, { FC, useState } from 'react';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import { InvitetoDealComponents } from '@Helper/Interfaces';
import { useTranslation } from 'react-i18next';
import TagInput from '@components/UI/TagInput/TagInput';
import { useAppDispatch, useAppSelector } from '@Store/hooks';
import { getPurePlaybookList } from '@Store/feature/purePlaybookSlice';
import {
  getPlayBookDetail,
  getUsersList,
} from '@Store/feature/playBookDetailSlice';
import { toast } from 'react-toastify';
import { CoreServices } from '@Helper/CoreServices';
import { useParams } from 'react-router-dom';
import { ComponentHelper } from '@Helper/Infra';

type Props = {
  onClose: () => void;
  selectedWorkStream: SelectedInvitetoDealItem;
};

const PersonModal: FC<Props> = ({ onClose, selectedWorkStream }) => {
  const [newUserEmailList, setNewUserEmailList] = useState<string[]>([]);
  const [newUserMessage, setNewUserMessage] = useState<string>('');
  const [hasOwner, sethasOwner] = useState(false);
  const purePlaybooks = useAppSelector(getPurePlaybookList);
  const { userList } = useAppSelector(getPlayBookDetail);
  const { id } = useParams();

  const dispatch = useAppDispatch();
  const coreService = new CoreServices();
  const componentHelper = new ComponentHelper();

  const { t } = useTranslation();
  React.useEffect(() => {
    const elem = purePlaybooks
      ?.filter(
        item => item.functionalArea && item.functionalArea?.isDeleted !== true
      )
      ?.find(
        i => i.functionalAreaId === selectedWorkStream.item.functionalAreaId
      );

    if (elem) {
      const wpUser = userList.filter(
        u => u.functionalAreaId === elem.functionalAreaId
      );
      sethasOwner(wpUser.filter(i => i.userRole === 'owner').length > 0);
    }
  }, [selectedWorkStream, purePlaybooks, userList]);

  const addUserWorkstream = async () => {
    let isTeammate = false;

    if (newUserEmailList.length < 1) {
      toast.error('Please enter the email', {
        position: 'top-right',
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: 'light',
      });
      return;
    }

    const wpUsers = userList.filter(
      u => u.functionalAreaId === selectedWorkStream.item.functionalAreaId
    );

    if (
      wpUsers &&
      wpUsers.find(item => newUserEmailList.includes(item.username))
    ) {
      toast.error(
        'You are trying to add an e-mail that has been added before, please check the e-mails and try again.',
        {
          position: 'top-right',
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: 'light',
        }
      );
      return;
    }

    if (wpUsers && wpUsers.filter(u => u.userRole === 'owner').length > 0) {
      isTeammate = true;
    }

    if (isTeammate) {
      if (!newUserEmailList) {
        toast('Please enter a valid email');
        return;
      }
      if (!purePlaybooks) {
        return;
      }

      coreService
        .inviteProject(
          newUserEmailList,
          selectedWorkStream.item.id,
          newUserMessage
        )
        .catch(err => {
          toast(err?.message ?? 'Something has wrong, please try again later');
        })
        .then(async resp => {
          if (resp.message) {
            toast(resp.message);
          } else {
            id && dispatch(getUsersList(id));
            onClose();
            toast('Successfully Invited');
          }
        });

      onClose();
      return;
    }

    const data = await componentHelper.createDealspaceUser(
      id ?? '',
      newUserEmailList,
      selectedWorkStream.item.id,
      newUserMessage
    );

    if (data?.errorCode && data?.errorCode !== '') {
      toast.error(data?.message, {
        position: 'top-right',
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: 'light',
      });

      return;
    }

    if (![201, 200].includes(data?.status)) {
      toast('Error ' + data.message);
      return;
    }

    id && dispatch(getUsersList(id));
    onClose();
    toast('Successfully invited');
  };

  return (
    <Dialog
      open={true}
      onClose={onClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      className="add-func-dialog"
    >
      <div className="dialog-header">
        <div className="dialog-title">
          Invite to {selectedWorkStream.item.project.name}
        </div>
        <button className="dialog-close-button" onClick={onClose}>
          <Icons.Cancel color="#000000" />
        </button>
      </div>
      <div className="dialog-content">
        <div style={{ display: 'flex' }}>
          <div className="dialogDescription">
            <div className="taskDetailDescriptionHead">
              {t('playbook.modal.inviting')}
            </div>
            <div className="buttonInvitingContent">
              {selectedWorkStream.item.project.name ===
              'Integration Management Office' ? (
                <button className={`editTaskName buttonInviting active`}>
                  IMO
                </button>
              ) : (
                <button
                  className={`editTaskName buttonInviting active`}
                  //onClick={() => setInvitingType('Functional Lead')}
                >
                  {hasOwner ? 'Function Teammate' : 'Function Lead'}
                </button>
              )}
            </div>
          </div>
          {selectedWorkStream.item.project.name !==
            'Integration Management Office' && (
            <div className="dialogDescription" style={{ flex: 1 }}>
              <div className="taskDetailDescriptionHead">Choose Function</div>

              <Select
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                className="customOutlinedInput"
                IconComponent={ArrowDropDownIcon}
                placeholder="Select function"
                readOnly
                defaultValue={selectedWorkStream.item.project.name}
              >
                {purePlaybooks
                  ?.filter(
                    item =>
                      item.functionalArea &&
                      item.functionalArea?.isDeleted !== true
                  )
                  ?.map((i, index) => {
                    return (
                      <MenuItem
                        //onClick={() => setNewUserFunctionalId(i.id)}
                        value={i.functionalArea?.name}
                        key={index}
                      >
                        {i.functionalArea?.name}
                      </MenuItem>
                    );
                  })}
              </Select>
            </div>
          )}
        </div>
        <div className="dialogDescription">
          <div className="taskDetailDescriptionHead">
            {t('playbook.modal.email')}
          </div>
          <TagInput
            defaultValues={newUserEmailList}
            setValue={e => setNewUserEmailList(e)}
            type="email"
            placeholder="Type and enter the email"
          />
          {/* <div className="editTaskName">
            <InputBase
              value={newUserEmail}
              onChange={evt => setNewUserEmail(evt.target.value)}
              placeholder="Enter their email"
              style={{ width: '100%' }}
            />
          </div> */}
        </div>
        <div className="dialogDescription">
          <div className="taskDetailDescriptionHead">
            {t('playbook.modal.message')}
          </div>
          <div className="editTaskName">
            <InputBase
              value={newUserMessage}
              onChange={evt => setNewUserMessage(evt.target.value)}
              multiline
              placeholder={t('playbook.modal.message_placeholder')}
              style={{ width: '100%', minHeight: 94 }}
            />
          </div>
        </div>
      </div>
      <div className="dialog-footer">
        <Button
          onClick={() => {
            addUserWorkstream();
          }}
          className="FuchsiaBlueButton"
          style={{ width: 148 }}
        >
          <span>{t('playbook.modal.send')}</span>
        </Button>
      </div>
    </Dialog>
  );
};

export default PersonModal;
